import React from "react";
import { Arrow as KonvaArrow } from "react-konva";
const Arrow = ({ shape, shapeProps }) => {
	return (
		<KonvaArrow
			{...shapeProps}
			points={shape.points}
			stroke="black"
			fill="black"
			key={shape.id}
		/>
	);
};

export default Arrow;
